<template>
  <div class="skin-dress-flyer">
    <img src="@/assets/img/skin_dress_flyer_front.jpg" alt="マナビス スキンドレス チラシ表面" />
    <img src="@/assets/img/skin_dress_flyer_back.jpg" alt="マナビス スキンドレス チラシ裏面" />
  </div>
</template>

<style scoped>
.skin-dress-flyer img {
  display: block;
  width: 100%;
  height: auto;
}

.skin-dress-flyer img + img {
  margin-top: 5px;
}
</style>
